export const ViberButton = () => {
  const phoneNumber = "+306933223378";
  // viber:// link opens the Viber app and starts a chat
  const viberLink = `viber://chat?number=${encodeURIComponent(phoneNumber)}`;

  return (
    <a
      href={viberLink}
      data-testid="viber-button"
      title="Επικοινωνία μέσω Viber"
      aria-label="Viber"
      className="fixed left-6 bottom-6 z-40 group"
    >
      <div className="relative">
        {/* Pulsing ring */}
        <span className="absolute inset-0 rounded-full bg-[#7360F2] opacity-60 animate-ping" />
        {/* Button */}
        <div className="relative h-14 w-14 rounded-full bg-gradient-to-br from-[#8B7CFF] to-[#5E54D9] flex items-center justify-center shadow-2xl shadow-[#7360F2]/40 hover:scale-110 transition-transform">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-7 w-7 fill-white"
          >
            <path d="M11.4 0C9.5.1 5.5.4 3.3 2.4 1.6 4.1 1 6.5.9 9.6c0 3 0 7 4 8.1V21s0 .5.3.6c.4.1.6-.2.9-.4.2-.2 1.4-1.6 2-2.3 2.7.2 4.8-.3 5-.4.6-.2 3.8-.6 4.3-4.8.5-4.4-.2-7.2-1.6-8.4-.4-.4-2.1-1.6-5.9-1.6 0 0-.4-.1-1.5 0zm.1 1.6c3.2 0 5 .5 5.6 1 1.2 1 1.8 3.5 1.4 7.2-.4 3.5-3 3.8-3.5 3.9-.2.1-2.2.5-4.6.3 0 0-1.8 2.2-2.4 2.8-.2.2-.4.3-.5.3-.2-.1-.2-.3-.1-.6V14.4c-3.4-1-3.2-4.5-3.2-7 .1-2.5.6-4.6 2-5.8 1.8-1.7 5.3-2 5.3-2zm.2 2.1c-.1 0-.2.1-.2.2 0 .2.1.2.2.2 1.7 0 3.1.5 4.1 1.5 1 1 1.4 2.3 1.4 4 0 .1.1.2.2.2s.2-.1.2-.2c0-1.8-.5-3.2-1.5-4.3-1.1-1-2.6-1.6-4.4-1.6zM7.6 5.2c-.2 0-.5.1-.7.2-.5.4-1 1-1.3 1.8-.2.4-.1 1 0 1.1l.1.1c.4.6.8 1.1 1.3 1.6.5.5 1.1 1 1.7 1.4l.1.1.6.5c.5.5 1.1.9 1.6 1.3.5.4 1.1.7 1.6 1l.1.1c.1 0 .7.2 1.2 0 .8-.3 1.4-.8 1.8-1.3.1-.2.2-.4.2-.7-.1-.5-1-1.1-1.5-1.4-.1 0-.2-.1-.3-.2-.4-.2-.7-.3-.9 0-.1 0-.1.1-.1.1-.2.2-.5.5-.6.5h-.2c-.5-.2-1.1-.5-1.7-1.1l-.1-.1c-.6-.6-.9-1.2-1.1-1.7v-.2c0-.1.3-.4.5-.6 0 0 .1-.1.1-.2.2-.2.1-.6 0-.9 0-.1-.1-.2-.1-.3-.3-.5-.9-1.4-1.4-1.5-.1.1-.2.1-.3.1zm4.7-.4c-.1 0-.2.1-.2.2s.1.2.2.2c1.3 0 2.4.4 3.2 1.3.8.8 1.2 1.8 1.2 3.2 0 .1.1.2.2.2s.2-.1.2-.2c0-1.5-.4-2.7-1.3-3.5-.9-.8-2.1-1.4-3.5-1.4zm.2 1.4c-.1 0-.2.1-.2.2 0 .1.1.2.2.2.9 0 1.6.3 2.1.8.5.5.8 1.3.8 2.2 0 .1.1.2.2.2s.2-.1.2-.2c0-1-.3-1.9-.9-2.5-.6-.6-1.4-.9-2.4-.9z"/>
          </svg>
        </div>
      </div>
    </a>
  );
};
